<template>
    <v-main class="pt-0">
        <v-layout>
            <v-flex xs12 sm8 offset-sm2>
                <h1>About Us</h1>
            <v-card class="rounded-xl mt-0">
                <!-- <MainImage /> -->
                <v-card-text>
                    <div>
                        <!-- <hr> -->
                        <br>
                        <p>DMECOMPLY, LLC was founded by David A Cox, CEO & President. Cox has thirty years’ experience in software design and development. His experience includes providing technology for financial institutions, retail companies and medical clinics, with an emphasis on detail and ease of use, while offering top-tier customer support. We have successfully incorporated that experience in DMECOMPLY, LLC. Cox is joined by a team of programmers, practitioners and clinicians to meet our goal, which is to provide our customers with the best solutions to efficiently manage patients and produce the documentation necessary for patient record keeping and payment for services. We accomplish this by continually improving and updating our software solutions to meet this goal.</p>
                    </div>
                </v-card-text>
            </v-card>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
// import MainImage from './MainImage'

export default {
    name: "About",
    // components: {
    //     MainImage
    // }
}
</script>

<style scoped>
    h1 {
        text-align: center;
        margin: 20px;
    }
</style>